import {SubMenuProps} from './SubMenu';
import React from 'react';
import {CheckCircle, Colors} from '../../../ui-components/Iconpack';
import MonoIcon from '../../../assets/icons/mono-Effect.svg';

export const EffectsSubMenu: React.FC<SubMenuProps> = (props) => {
    return (
        <div className='flex flex-col text-[14px] font-[700] text-[#FFFFFF]'>
            <div className='flex items-center'>
                <div className='block cursor-pointer items-center justify-center rounded-[6px] border-[2px] border-[#4E5BA6] bg-[#717BBC] p-[12px] md:mx-[16px] md:hidden'>
                    <Colors color='#FFFFFF' />
                </div>
                <div className='flex flex-col pl-[6px] text-[14px] font-[700] text-[#FFFFFF] md:pl-0'>
                    <span>ADD EFFECTS</span>
                </div>
            </div>
            <div
                className={'cursor-pointer'}
                onClick={() => {
                    props.trackEvent('GreyTonEffectClicked', {is_undo: props.transformationObject.monoGrayToneApplied});
                    props.updateTransformationObject({
                        ...props.transformationObject,
                        monoGrayToneApplied: !props.transformationObject.monoGrayToneApplied,
                    });
                }}>
                <img
                    className='absolute mt-[15px] cursor-pointer'
                    src={MonoIcon}
                    alt='mono-effect'
                    width={76}
                    height={77}
                />
                {props.transformationObject.monoGrayToneApplied && (
                    <div className={'relative z-10 my-10 ml-6 flex'}>
                        <CheckCircle />
                    </div>
                )}
            </div>
        </div>
    );
};
